<mat-toolbar class="main-toolbar mat-elevation-z2">
  <div class="tw-flex min-[960px]:tw-hidden">
    <button (click)="sidenav.open()"
      mat-icon-button>
      <mat-icon>menu</mat-icon>
    </button>
  </div>
  <div class="main-toolbar__button-wrapper">
    @if (showFavorites) {
      <gd-favorites
      class="!tw-hidden min-[960px]:!tw-flex"></gd-favorites>
    }

    <!-- spacer -->
    @if ((dir$ | async) === 'rtl') {
      <span class="tw-flex-1"
      ></span>
    }
    <!-- CONTENT QUEUES-->
    <div style="border-right: 1px solid rgba(0, 0, 0, 0.12); padding: 0 4px;">
      <a [routerLink]="['dashboard/content-queues']">
        @if (showContentQueues) {
          <button
            mat-icon-button
            i18n-matTooltip
            matTooltip="Content Queues">
            <mat-icon class="main-toolbar__content-queue-icon" svgIcon="content-queues-icon"></mat-icon>
          </button>
        }
      </a>
    </div>
    <!-- spacer -->
    @if ((dir$ | async) === 'rtl') {
      <span class="tw-flex-1"
      ></span>
    }
    <!-- breadcrumbs -->
    @if (showBreadcrumbs) {
      @switch (activeSection) {
        @case ('files') {
          <gd-file-manager-breadcrumb
          class="!tw-hidden min-[960px]:!tw-flex"></gd-file-manager-breadcrumb>
        }
        @default {
          <gd-breadcrumbs
          class="!tw-hidden min-[960px]:!tw-flex"></gd-breadcrumbs>
        }
      }
    }
  </div>
  <!-- spacer -->
  @if ((dir$ | async) !== 'rtl') {
    <span class="tw-flex-1"
    ></span>
  }

  <gd-user-menu></gd-user-menu>

  <!-- spinner of doom, indicates something is loading from the api, or that something broke -->
  <div style="position: absolute; bottom: -1px; left: 0; right: 0;">
    <mat-progress-bar mode="indeterminate"
    [style.opacity]="loadingBarActive ? 1 : 0"></mat-progress-bar>
  </div>

</mat-toolbar>

@if (sectionHasFloatingTabHeader) {
  <div
    class="gd-toolbar__floating-tab-header-placeholder">
    <!-- This space is reserved so that it can be occupied by floating tab headers or toolbars -->
    <!-- The floating section header or tab select is placed over this using `position: fixed` -->
  </div>
}
